<template>
  <section class="edit-decoration-policy-form width-700">
    <!--    <el-form-->
    <!--      ref="form"-->
    <!--      :rules="rules"-->
    <!--      :disabled="showBuyable"-->
    <!--      :model="formData">-->
    <!--      <div class="box">-->
    <!--        <h3>More Benefits</h3>-->
    <!--        <div class="form-item">-->
    <!--          <v-checkbox-group-->
    <!--            v-model="formData.benefits"-->
    <!--            :block="true"-->
    <!--            :list="localAllOptions.benefits" />-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </el-form>-->
    <decoration-policy-form
      ref="decoration-policy-form"
      :form="form"
      :isRequired="isRequired || editType == 3"
      :editType="editType"
      :isRefer="isRefer"
      :file-list="fileList"
      :showBuyable="showBuyable"
      :checkRefer="checkRefer"
      @getFormData="getFormData" />
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import DecorationPolicyForm from '@/views/quoting/modules/decoration/form/decoration-policy-form'
import MixinSame from '@/mixins/same'

export default {
  components: {
    DecorationPolicyForm
  },
  mixins: [MixinOptions, MixinRules,MixinSame],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    editType:{
      type:Number,
      default:0
    },
    checkRefer:{
      type:Number,
      default:0
    },
    showBuyable: {
      type: Boolean,
      default: false
    },
    isRefer: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      formData: {
        // benefits: []
      }
    }
  },
  computed: {
    localAllOptions() {
      return this.allOptions24
    },
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        if(val) {
          Object.keys(this.formData).some(key => {
            if(key in val) {
              this.formData[key] = val[key]
            }
          })
        }
      }
    }
  },
  methods: {
    submitForm(otherData = {}) {
      this.$refs['decoration-policy-form'].submitForm(otherData)
      // this.$refs['form'].validate(valid => {
      //   if(valid) {
      //
      //   }
      // })
    },
    getFormData(data, otherData) {
      // 整合其他數據
      const result = {
        ...data,
        ...this.formData
      }
      this.$emit('getFormData', result, otherData)
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
